import {Grid} from '@mui/material';
import {AppDialog} from 'components/dialogs';
import {AppBoardSelect, AppSprintSelect, AppStatusSelect, AppWorkspaceSelect} from 'components/form';
import {useTransferItems} from 'hooks';
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import {BoardTableViewActionsCommonProps} from '../TableViewMultiRowSelectedActions';
import ActionsTitle from './ActionsTitle';
interface TransferItemModel {
    workspaceId: string;
    boardId: string;
    itemStatusId: string;
    sprintId?: string;
}
interface BoardViewTransferToAnotherBoardDialogProps extends BoardTableViewActionsCommonProps {}
export const BoardViewTransferToAnotherBoardDialog: React.FC<BoardViewTransferToAnotherBoardDialogProps> = ({
    selectedRows,
    onClose,
    open,
}) => {
    const {boardId, workspaceId} = useParams();
    const {transferItems, transferItemsLoading, transferItemsResponse} = useTransferItems();
    const {handleSubmit, control, watch} = useForm<TransferItemModel>({
        defaultValues: {
            workspaceId: workspaceId ?? '',
            boardId: boardId ?? '',
            itemStatusId: '',
            sprintId: undefined,
        },
    });
    const watchWorkSpaceId = watch('workspaceId');
    const watchBoardId = watch('boardId');

    const onSubmitHandler = (data: TransferItemModel) => {
        // Handle the transfer logic here
        transferItems({
            variables: {
                input: {
                    itemIds: selectedRows.map(item => item.id),
                    itemStatusId: data.itemStatusId,
                    sprintId: data.sprintId,
                },
            },
        });
        // You can call a mutation or API to perform the transfer
    };
    useEffect(() => {
        if (transferItemsResponse && !transferItemsLoading) {
            onClose(true);
        }
    }, [transferItemsResponse, transferItemsLoading]);
    return (
        <>
            <AppDialog
                isForm={true}
                onFormSubmit={handleSubmit(onSubmitHandler)}
                footerProps={{
                    onCancelClick: () => onClose(false),
                    submitButtonProps: {
                        type: 'submit',
                        isLoading: transferItemsLoading,
                        disabled: transferItemsLoading,
                    },
                }}
                fullWidth
                maxWidth="sm"
                open={open}
                title={<ActionsTitle title="Transfer Items" selectedRows={selectedRows} />}
                onCloseDialog={onClose}
                children={
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <AppWorkspaceSelect
                                    fullWidth
                                    label="Workspaces"
                                    control={control}
                                    name="workspaceId"
                                    required
                                    shouldReturnValueOnly
                                    disableClearable={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AppBoardSelect
                                    control={control}
                                    name="boardId"
                                    label="Boards"
                                    shouldReturnValueOnly
                                    fullWidth
                                    required
                                    workspaceSlug={watchWorkSpaceId}
                                    disabled={!watchWorkSpaceId}
                                    disableClearable={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AppStatusSelect
                                    control={control}
                                    name="itemStatusId"
                                    label="Status"
                                    required
                                    shouldReturnValueOnly
                                    boardSlug={watchBoardId}
                                    disableClearable={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AppSprintSelect
                                    control={control}
                                    name="sprintId"
                                    label="Sprints"
                                    shouldReturnValueOnly
                                    boardSlug={watchBoardId}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    );
};

export default BoardViewTransferToAnotherBoardDialog;
